/**
 * Initial state for the agentsReducer.
 *
 * @type {Object}
 * @property {Array} agents - List of agents.
 * @property {Array} agentList - List of agents for agentList.
 * @property {boolean} loading - Loading state for agent operations.
 * @property {string|null} error - Error message for agent operations.
 */
const initialState = {
  agents: [],
  agentList: [],
  loading: false,
  error: null
};

/**
 * Agents Reducer
 *
 * This reducer manages the state related to agents and agent lists.
 * It handles actions to update the list of agents and the agent list data,
 * as well as loading and error states.
 *
 * @function
 * @param {Object} state - The current state of the reducer.
 * @param {Object} action - The action dispatched to the reducer.
 * @param {string} action.type - The type of action to handle.
 * @param {Object} action.data - The payload data containing agent information.
 * @param {Object} action.err - The error information for failed operations.
 * @returns {Object} The new state after the action is applied.
 */
const agentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_AGENTS_DATA': {
      return {
        ...state,
        agents: action.data.agents,
        loading: false,
        error: null
      };
    }
    case 'SET_AGENT_LIST_DATA': {
      return {
        ...state,
        agentList: action.data.agents,
        loading: false,
        error: null
      };
    }
    case 'AGENTS_LOADING': {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case 'LOAD_DATA_FAILURE': {
      return {
        ...state,
        loading: false,
        error: action.err?.message || 'An unexpected error occurred.'
      };
    }
    default:
      return state;
  }
};

export default agentsReducer;
